module.exports = __webpack_public_path__ + "static/media/geese512x384.81239809.jp2";